import { getSharedApiClient } from "@/shared-utils";

import { ChatMetadata } from "../types";

export const getChatMetadata = async (partner: string, chatId: string): Promise<ChatMetadata[]> => {
    const response = await getSharedApiClient().post(`api/chat-metadata`, {
        json: { partner, chatIds: [chatId] },
        retry: 0,
    });

    return response.json<ChatMetadata[]>();
};
